// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"874434a9","172":"33e38634","201":"25e737b8","210":"af2e8c93","225":"f93db4b8","303":"67dbb752","423":"1f54e2fb","494":"59c9bf62","596":"1aa7cfdf","803":"27fe3be7"}[chunkId] + ".chunk.js";
};